import cache from './cache.js';
import getOperatingSystem from './getOperatingSystem.js';

export default cache('isMacOs', function isMacOs() {
  return getOperatingSystem().name.includes('Mac');
});